/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import { LOADER_STATUS,CLEAR_DEFAULT_VALUE,STORE_ENTITY,STORE_SINGLE_GSTIN, STORE_GSTIN, STORE_PERIOD } from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  selectedEntity: "",
  selectedGstin: [],
  selectedSingleGstin:"",
  selectedPeriod: "",
};

/* eslint-disable default-case, no-param-reassign */
const gstr3bCommonReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }

     case CLEAR_DEFAULT_VALUE:
        return {
            ...initialState
        }
      case STORE_ENTITY:
        return {
          ...state,
          selectedEntity:action.selectedEntity
        }
      case STORE_GSTIN:
        return {
          ...state,
          selectedGstin:action.selectedGstin
        }
        case STORE_SINGLE_GSTIN:
          return {
            ...state,
            selectedSingleGstin:action.selectedSingleGstin
          }
      case STORE_PERIOD:
        return {
          ...state,
          selectedPeriod:action.selectedPeriod
        }

      default:
        return state;
    }
  };

export default gstr3bCommonReducer;
